module.exports = __webpack_public_path__ + "static/media/sf_1800.f3b7e6331cf5f2b902dea8f47ffa874e.png";